/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */


/**
 * Conservation credits filter.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export default (value: number): string => {
    return (+value).toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,');
};
